import { Dispatch } from "redux";
import request from "../../util/request";
import actions from "../../util/actions";
import errorHandler from "../../util/error-handler";

export const getEvents = (search: string, page: number, per_page: number) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.EVENTS_HTTP_LOADING
    });

    request({
      method: "get",
      pathname: "getEvents",
      params: { search, page, per_page }
    })
      .then((response) => {
        dispatch({
          type: actions.EVENTS_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });

        dispatch({
          type: actions.SET_EVENTS_DETAILS,
          payload: {
            ...response.data.content
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.EVENTS_HTTP_ERROR, error, dispatch);
      });
  };
};
